import type {
    ILegacyIndustryFilterDto,
    IndustryValueItemDto,
} from "app/pages/sales-intelligence/domain/industry/types/filter-values";
import { type InclusionOption, inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

/** @deprecated Value object of the legacy industry filter. Superseded by `IndustryFilterValue` (SI-8780). */
export class LegacyIndustryFilterValue {
    public readonly inclusion: InclusionOption;
    public readonly values: readonly IndustryValueItemDto[];

    static readonly defaultInclusion: InclusionOption = inclusionOptionMap.includeOnly;

    constructor(value?: ILegacyIndustryFilterDto) {
        const dto = LegacyIndustryFilterValue.toDtoValue(value);

        this.inclusion = dto.inclusion;
        this.values = dto.values;
    }

    static toDtoValue(value: Partial<ILegacyIndustryFilterDto> = {}): ILegacyIndustryFilterDto {
        const { values = [], inclusion = LegacyIndustryFilterValue.defaultInclusion } = value;

        return {
            inclusion,
            values,
        };
    }

    hasIndustries(): boolean {
        return this.values.length > 0;
    }

    // fallow-ignore-next-line unused-class-member
    isEmpty(): boolean {
        return !this.hasIndustries();
    }
}
